import { DataSource, Label, Layout, Map, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutDispatchZoneList extends Layout {
    labelSearchDispatchZone: Label;
    mapRoute: Map;
    sourceDispatchZone: DataSource;
    splitterZoneArea: Splitter;
    tableDispatchZoneList: Table;
}
